import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import './Boutton.css';
import { useShoppingCard } from '../../Context/ShoppingCardContext';
import CartIcon from './ButtonPanier/CartIcon';

const Boutton = (props) => {
  const { addItem } = useShoppingCard();
  const [isAnimating, setIsAnimating] = useState(false);
  const [justAdded, setJustAdded] = useState(false);
  const [bump, setBump] = useState(0);
  const timeoutsRef = useRef([]);

  useEffect(() => () => {
    timeoutsRef.current.forEach(clearTimeout);
  }, []);

  const handleClick = () => {
    addItem(props.item, props.dimension2, props.dimension, props.price, props.quantite);

    setIsAnimating(true);
    setJustAdded(true);
    setBump((b) => b + 1);

    timeoutsRef.current.push(
      setTimeout(() => setIsAnimating(false), 600),
      setTimeout(() => setJustAdded(false), 1600)
    );
  };

  return (
    <div className="button-container">
      <motion.button
        type="button"
        onClick={handleClick}
        whileTap={{ scale: 0.97 }}
        className={`boutton_ajouterPanier ${isAnimating ? 'animate' : ''} ${justAdded ? 'is-added' : ''}`}
      >
        <span className="button-content">
          <AnimatePresence mode="wait" initial={false}>
            {justAdded ? (
              <motion.span
                key="added"
                className="button-state"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2 }}
              >
                <FiCheck className="cart-icon" />
                <span>Ajouté au panier</span>
              </motion.span>
            ) : (
              <motion.span
                key="idle"
                className="button-state"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2 }}
              >
                <CartIcon size={18} bump={bump} className="cart-icon" />
                <span>Ajouter au panier</span>
              </motion.span>
            )}
          </AnimatePresence>
        </span>
        <div className="button-pulse"></div>
      </motion.button>
    </div>
  );
};

export default Boutton;
